export default __webpack_public_path__ + "static/optical-fiber-ebbe9d5f2ef26f46767655fd270edfa9.png";